// mixin.js
import GAErrorEvent from '@/mixins/vue/gAnalytics/GAErrorEvent';
import { geoIP } from '@/plugins/papybase/papybaseInit';
import { MUTATE_GEOIPS } from '@/store/modules/geoip';
import { Component, Mixins } from 'vue-property-decorator';

// You can declare a mixin as the same style as components.
@Component
export default class GeoIPMixin extends Mixins(GAErrorEvent) {
    public async integrateGeoIPsFromBackEndToLocalStorage(jwt?: string) {
        try {
            let theJwt;
            if (jwt) {
                theJwt = jwt;
            } else {
                theJwt = this.jwt;
            }
            const geoIPs = await geoIP.getAllGeoIPs(theJwt);
            // geoIPs.forEach((theGeoIP) => {
            //     const theIP = this.$store.getters.getIPAPI(theGeoIP.ip);
            //     if (!theIP) {
            //         this.fetchLocationFromIP(theGeoIP.ip).then((res) => {
            //             this.$store.dispatch(ADD_IPAPI, res);
            //         }).catch((err) => {
            //             console.error(err);
            //         });
            //     }
            // });
            this.$store.commit(MUTATE_GEOIPS, geoIPs);
        } catch (error) {
            this.errorEvent('getAllGeoIPs', error);
            throw new Error(error);
        }
    }

    get jwt() {
        return this.$store.getters.getJwt;
    }
}
